import { guardString } from "../strings";
import type { Nullable } from "../types";
import { Constants } from "./constants";

export function getOrderNumberString(orderNumber: Nullable<string | number>) {
	if (!orderNumber) return guardString(null);

	return [
		Constants.ORDER_NUMBER_PREFIX,
		orderNumber.toString().padStart(Constants.ORDER_NUMBER_PADDING, "0"),
	].join("");
}
